<script>
  /**
   * @type {"success"|"warning"|"error"}
   */
  export let type = "success"

  $: color = function(){
    switch (type) {
      case "success":
        return "#3b5f3c"
      case "warning":
        return "#ef7918"
      case "error":
        return "#e16d6d"
    }
  }()
</script>

<span style="color: {color}">
  <slot />
</span>
